export default __webpack_public_path__ + "static/media/race-icon.a3ff80a6.svg";